
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[category]/[post]",
      function () {
        return require("private-next-pages/[lang]/[category]/[post].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[category]/[post]"])
      });
    }
  